import React, { useContext, useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  ManageDataInPrescription,
  updateManagePrescriptionSubmissionData,
} from "../../../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../../../assets/AssetsStore";
import { getInstructions, getInvestigation, getInvestigaton, getMedicationList, saveInstructions, saveInvestigation, saveMedicine } from "../../../../../reducers/symptom.api";
import DataBox from "../../../../ManagePrescriptionComponents/DataBox/DataBox";
import InstructionBox from "../../../../ManagePrescriptionComponents/InstructionBox/InstructionBox";
import InvestigationBox from "../../../../ManagePrescriptionComponents/Invesigation/InvestigationBox";

import MedicationBox from "../../../../ManagePrescriptionComponents/MedicationBox/MedicationBoxbk";
import { PrescriprionContext } from "../../../PrintPrescription";
import styles from "./index.module.scss";

function TreatmentAdvice() {
  const {  submissionData } = useSelector(
    (state) => state.managePrescription
  );

  const [initialInvestigation,setInitialInvestigation] = useState([]);
  const selectedInvestigation = submissionData?.investigations || [];

  const [initialInstruction, setInitialInstruction] = useState([]);
  const selectedInstruction = submissionData?.instructions || [];

  const [initialMedication,setInitialMedication] = useState([]); 
  const selectedMedication = submissionData?.medications || [];

  const [detailMedicalData,setDetailedMedicalData] = useState([]);

  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  const dispatch = useDispatch();

  const isSelected = (data, name) => {
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
      return res && res.length > 0;
    }
  };

  const handleSearchInvestigation = (value) => {
    let _item = initialInvestigation.filter((e) => e.name == value)[0];
    let _isSelected = selectedInvestigation.filter((e) => e.name == value)[0];

    if (!_isSelected) {
      toggleInvestigation(_item);
    }
  };
  const handleAddInvestigation = (name) => {
    saveInvestigation(name,handleInvestigationData);
    
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "investigation",
        payload: name,
        existing: initialInvestigation,
      })
    );
    toggleInvestigation(name);
  };
  const toggleInvestigation = (name) => {
    console.info("initialInvestigation",selectedInvestigation)
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "investigation",
        payload: name,
        existing: selectedInvestigation,
        initial: initialInvestigation,
      })
    );
  };

  const onChangeNoteInvestigation = (e) => {
    let { value } = e?.target;
    handleWholeData("investigationNote",value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        investigation_note: value,
      })
    );
  };

  const handleSearchInstruction = (value) => {
    let _item = initialInstruction.filter((e) => e.name == value)[0];
    let _isSelected = selectedInstruction.filter((e) => e.name == value)[0];
    if (!_isSelected) {
      toggleInstruction(_item);
    }
  };
  const handleAddInstruction = (name) => {
    saveInstructions(name.name,handleInstructionData)
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "instruction",
        payload: name,
        existing: initialInstruction,
      })
    );
    toggleInstruction(name);
  };



  const toggleInstruction = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "instruction",
        payload: name,
        existing: submissionData?.instructions,
        initial: initialInstruction,
      })
    );
  };

  // const handleSearchMedication = (value) => {

  //   if (initialMedication.includes(value)) {

  //     if (!isSelected(selectedMedication, value)) {
  //       dispatch(ManageMedicationInPrescription({ context: "Toggle", payload: value, existing: selectedMedication }))
  //     }

  //   }
  //   else {

  //     dispatch(ManageMedicationInPrescription({ context: "Add", payload: value, existing: initialMedication }))

  //   }

  // }
  const handleAddMedication = (name) => {
    saveMedicine(name.name,handleMedicationData);
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "medication",
        payload: name,
        existing: initialMedication,
      })
    );
    toggleMedication(name);
  };
  const toggleMedication = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "medication",
        payload: name,
        existing: selectedMedication,
        initial: initialMedication,
      })
    );
  };

  const handleInstructionData = () => {
    getInstructions((res) => {
      setInitialInstruction(
        res.map((item) => {
          return {
            name: item.instructionName,
          };
        })
      );
    });
  };

  const handleMedicationData = () => {
    handleWholeData("loadingMedications",true);
    getMedicationList((res) => {
      setDetailedMedicalData(res.detailData);
      handleWholeData("loadingMedications",false);
      setInitialMedication(
        res.map((item) => {
          return {
            name: item.description,
            genericname:item.genericname
          };
        })
      );
    });
  };

  const handleInvestigationData = () => {
    getInvestigation((res) => {
      setInitialInvestigation(
        res.map((item) => {
          return {
            name: item.testname,
          };
        })
      );
    });
  };

  useEffect(() => {
    handleInstructionData();
    //handleInvestigationData();
    handleMedicationData();
  }, []);

  const medications = [
    "Sus Calpol (250 mg)",
    "Syr Meftal P",
    "Syr Ondem",
    "Syr Emeset",
    "Syr Emeset (2 mg)",
    "Syr Zinconia",
    "Syr Zincolife",
    "Syr Z & D DS",
  ];

  const data = [
    /* {
      name: "Investigations",
      icon: AssetStore.managePrescription.investigations,
      data: initialInvestigation,
      selectedData: selectedInvestigation,
      handleSearch: handleSearchInvestigation,
      handleAdd: handleAddInvestigation,
      toggle: toggleInvestigation,
      text: "Past Investigations",
      addTitle: "Add new investigation",
      onChangeNote: onChangeNoteInvestigation,
      haveNote: true,
      noteValue: submissionData?.investigation_note,
      title:"investigations"
    },*/
    {
      name: "Instructions",
      icon: AssetStore.managePrescription.instructions,
      data: initialInstruction,
      selectedData: selectedInstruction,
      handleSearch: handleSearchInstruction,
      handleAdd: handleAddInstruction,
      toggle: toggleInstruction,
      text: "",
      addTitle: "Add new instruction",
      haveNote: true,
    }, 
    {
      name: "Medications",
      icon: AssetStore.managePrescription.medication,
      data: initialMedication,
      selectedData: selectedMedication,
      handleSearch: handleAddMedication,
      handleAdd: handleAddMedication,
      toggle: toggleMedication,
      text: "Recent Medicines",
      addTitle: "Add new medicine",
    },
  ];

  const getComponent = (param_data) => {
    switch (param_data?.name) {
      /* case data[0]?.name:
        return (
          <InvestigationBox
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            haveNote={param_data?.haveNote}
          />
        );*/
      case data[0]?.name:
        return (
          <InstructionBox
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            haveNote={param_data?.haveNote}
          />
        ); 
      case data[1]?.name:
        return (
          <MedicationBox
            haveNote
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData || []}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            detailedData={detailMedicalData}
          />
        );
      default:
        return (
          <DataBox
            noteValue={param_data?.noteValue}
            onChangeNote={param_data?.onChangeNote}
            haveNote={param_data?.haveNote}
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            title ={param_data?.title}
          />
        );
    }
  };

  // console.log("selectedInvestigation",selectedInvestigation)

  return (
    <div className={styles.treatmentAdvice}>
      <Accordion
        className={styles.accordion}
        alwaysOpen
        defaultActiveKey={[0, 1, 2]}
      >
        {data.map((each, key) => {
          return (
            <div key={key}>
              <div className={styles.devider}>&nbsp;</div>
              <Accordion.Item
                className={
                  key >= data.length - 1 && styles.accordion_last_item_wrap
                }
                key={key}
                eventKey={key}
              >
                <Accordion.Header>
                  <span className={styles.accordion_header}>
                    <div className={styles.icon}>
                      <img src={each.icon} alt="" />
                    </div>
                    <span className={styles.accordion_header_title}>
                      {each.name}
                    </span>
                  </span>
                </Accordion.Header>

                <Accordion.Body>
                  {getComponent(each)}

                  {/* <DataBox
                                            data={each?.data}
                                            name={each?.name}
                                            haveNote={each?.haveNote}
                                        /> */}
                </Accordion.Body>
              </Accordion.Item>

              <div className={styles.devider}>&nbsp;</div>
            </div>
          );
        })}
      </Accordion>
    </div>
  );
}

export default TreatmentAdvice;
